if (!customElements.get('product-card-variants')) {
  class ProductCardVariants extends HTMLElement {
    constructor() {
      super();

      this.colors = this.querySelectorAll('[data-product-card-hover-init]');
      this.productCard = this.closest('[data-product-card]');
      this.primaryColor = this.productCard.querySelector('[data-product-card-hover-primary="true"]') || this.colors[0];

      if (!this.colors.length) {
        return;
      }
      this.colors.forEach((color) => {
        color.addEventListener('mouseover', this.updateProductCard.bind(this));
      });

      if (this.productCard) {
        this.productCard.addEventListener('mouseleave', () => {
          this.updateProductCard({ target: this.primaryColor });
        });
      }
    }

    updateProductCard(event) {
      let target = event.target;

      if (typeof target.dataset.productCardHoverImage === 'undefined') {
        target = event.target.closest('[data-product-card-hover-image]');
      }

      let image = target.dataset.productCardHoverImage;
      let url = target.dataset.productCardHoverUrl;
      let price = target.dataset.productCardHoverPrice;

      let parent = target.closest('[data-product-card-hover]');
      let images = parent.querySelector('[data-card-hover-image]').querySelectorAll('img');
      let variantImage = document.createElement('img');
      variantImage.setAttribute('src', image);

      variantImage.classList.add(
        'product-card__image--primary',
        'object-contain',
        'mb-0',
        'block',
        'relative',
        'z-10'
      );

      if (typeof target.dataset.cardHoverImageRotate !== 'undefined') {
        variantImage.classList.add('rotate-[270deg]');
      }
      variantImage.style.aspectRatio = '3/4';

      images.forEach((image) => {
        image.remove();
        // image.classList.add('opacity-0');
        // image.classList.remove('relative');
        // image.classList.add('absolute');
      });
      if (parent.querySelector('[data-card-hover-image]')) {
        parent.querySelector('[data-card-hover-image]').appendChild(variantImage);
        parent.querySelector('[data-card-hover-image]').href = url;
      }
      if (parent.querySelector('[data-card-hover-price] .price__item--regular')) {
        parent.querySelector('[data-card-hover-price] .price__item--regular').innerText = price;
      }

    }
  }

  window.ProductCardVariants = ProductCardVariants;

  customElements.define('product-card-variants', ProductCardVariants);
}
